import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { grayDarkM, backgroundGrayLightM, selectedLightM, textPrimaryM, grayLightM, surfaceM, selectedM, primaryHighlightM } from 'web-ui-kit/colors';
import AddToCartButton from 'web-ui-kit/buttons/AddToCartButton';
import SecondaryButton from 'web-ui-kit/buttons/SecondaryButton';
import LikeDislikeButtons from 'web-ui-kit/LikeDislikeButtons';
import { productCardButtonClicked, productCardClicked, productLikeStatusChanged, productCardColorTileClicked } from 'web-ui-kit/cards/ProductCardEvents';
import { toUSDString, toSentenceCase, truncateLines } from 'web-ui-kit/styleUtils';
import Tag from 'web-ui-kit/Tag';
import PromoIcon from 'web-ui-kit/assets/PromoIcon';
import { fontFamilyPrimary, LabelSmallStyles, BodySmallSmallStyles, BodySmallBoldLargeStyles, BodySmallStyles, BodySmallLargeStyles, fontWeightSemiBold } from 'web-ui-kit/typography';
import { RoundedSpinner } from 'web-ui-kit/loading';
import { CompressedImage } from 'web-services/Imgix';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19, _templateObject20, _templateObject21, _templateObject22, _templateObject23, _templateObject24, _templateObject25, _templateObject26, _templateObject27, _templateObject28;
/**
 *  We don't want to show certain tags that are present on the Product model.
 */


var BLACKLISTED_TAGS = ['Modsy Choice'];
var VARIANTS = ['', 'horizontal', 'thin', 'borderless'];
var ProductCardReferrer = {
  FAVORITES: 'favorites',
  HOTSPOT: 'hotspot',
  PDP: 'pdp',
  PDP_ALT: 'alternative',
  PID: 'products_in_design',
  PID_ALTS: 'design_alternatives',
  SHOP: 'shop'
};
/**
 * Visual representation of a product.
 */

function ProductCard(_ref) {
  var _curatedRecInternal$l, _curatedRecInternal$r, _curatedRecInternal$r2, _curatedRecInternal$r3, _curatedRecInternal$r4;

  var _ref$availabilityV = _ref.availabilityV2,
      availabilityV2 = _ref$availabilityV === void 0 ? {
    status: ''
  } : _ref$availabilityV,
      _ref$buttonConfig = _ref.buttonConfig,
      buttonConfig = _ref$buttonConfig === void 0 ? {
    visible: false,
    disabled: false,
    labelText: 'Find Alternatives',
    atcVisible: false,
    atcDisabled: false
  } : _ref$buttonConfig,
      _ref$cardPosition = _ref.cardPosition,
      cardPosition = _ref$cardPosition === void 0 ? 0 : _ref$cardPosition,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$currentState = _ref.currentState,
      currentState = _ref$currentState === void 0 ? '' : _ref$currentState,
      _ref$curatedRec = _ref.curatedRec,
      curatedRec = _ref$curatedRec === void 0 ? {} : _ref$curatedRec,
      _ref$dataTestId = _ref.dataTestId,
      dataTestId = _ref$dataTestId === void 0 ? '' : _ref$dataTestId,
      _ref$dislikeButtonCon = _ref.dislikeButtonConfig,
      dislikeButtonConfig = _ref$dislikeButtonCon === void 0 ? 'hover' : _ref$dislikeButtonCon,
      _ref$dispatch = _ref.dispatch,
      dispatch = _ref$dispatch === void 0 ? function () {} : _ref$dispatch,
      _ref$id = _ref.id,
      id = _ref$id === void 0 ? '' : _ref$id,
      _ref$image = _ref.image,
      image = _ref$image === void 0 ? '' : _ref$image,
      _ref$imgixProps = _ref.imgixProps,
      imgixProps = _ref$imgixProps === void 0 ? {} : _ref$imgixProps,
      _ref$isFreeShipping = _ref.isFreeShipping,
      isFreeShipping = _ref$isFreeShipping === void 0 ? false : _ref$isFreeShipping,
      _ref$isLoggedIn = _ref.isLoggedIn,
      isLoggedIn = _ref$isLoggedIn === void 0 ? true : _ref$isLoggedIn,
      _ref$isMaterial = _ref.isMaterial,
      isMaterial = _ref$isMaterial === void 0 ? false : _ref$isMaterial,
      _ref$isSellable = _ref.isSellable,
      isSellable = _ref$isSellable === void 0 ? true : _ref$isSellable,
      _ref$isRestricted = _ref.isRestricted,
      isRestricted = _ref$isRestricted === void 0 ? false : _ref$isRestricted,
      _ref$isOutOfStock = _ref.isOutOfStock,
      isOutOfStock = _ref$isOutOfStock === void 0 ? false : _ref$isOutOfStock,
      _ref$likeDislikeEnabl = _ref.likeDislikeEnabled,
      likeDislikeEnabled = _ref$likeDislikeEnabl === void 0 ? true : _ref$likeDislikeEnabl,
      _ref$likeStatus = _ref.likeStatus,
      likeStatus = _ref$likeStatus === void 0 ? 0 : _ref$likeStatus,
      _ref$mainType = _ref.mainType,
      mainType = _ref$mainType === void 0 ? '' : _ref$mainType,
      _ref$name = _ref.name,
      name = _ref$name === void 0 ? '' : _ref$name,
      _ref$product = _ref.product,
      product = _ref$product === void 0 ? null : _ref$product,
      _ref$promos = _ref.promos,
      promos = _ref$promos === void 0 ? [] : _ref$promos,
      _ref$regularPrice = _ref.regularPrice,
      regularPrice = _ref$regularPrice === void 0 ? 0 : _ref$regularPrice,
      _ref$salePrice = _ref.salePrice,
      salePrice = _ref$salePrice === void 0 ? 0 : _ref$salePrice,
      _ref$source = _ref.source,
      source = _ref$source === void 0 ? '' : _ref$source,
      _ref$referrer = _ref.referrer,
      referrer = _ref$referrer === void 0 ? '' : _ref$referrer,
      _ref$tag = _ref.tag,
      tag = _ref$tag === void 0 ? '' : _ref$tag,
      _ref$variants = _ref.variants,
      variants = _ref$variants === void 0 ? {
    colors: [],
    sizes: []
  } : _ref$variants,
      _ref$uiMessaging = _ref.uiMessaging,
      uiMessaging = _ref$uiMessaging === void 0 ? {
    ctaTitle: '',
    isSellable: null
  } : _ref$uiMessaging,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? '' : _ref$variant;
  var isUnavailable = uiMessaging.ctaTitle === 'Currently Unavailable' || availabilityV2.status === 'OUT_OF_STOCK' || isOutOfStock;
  var isDiscontinued = uiMessaging.ctaTitle === 'Discontinued' || availabilityV2.status === 'DISCONTINUED';
  var unavailableText = 'Currently unavailable';

  if (variant === 'borderless' || variant === 'thin') {
    unavailableText = isDiscontinued ? 'Discontinued' : 'Out of stock';
  }

  var isSellableStatus = typeof uiMessaging.isSellable === 'boolean' ? uiMessaging.isSellable : isSellable;
  var showPrice = (salePrice > 0 || regularPrice > 0) && isSellableStatus && isLoggedIn && !isUnavailable && !isMaterial && !isRestricted && tag !== 'Stand-in' && tag !== 'Exact match' && (variant !== 'borderless' && variant !== 'thin' || !isDiscontinued);
  var secondaryButtonVisible = buttonConfig.visible && !isMaterial && variant !== 'horizontal';
  var ctaVisible = secondaryButtonVisible;
  var curatedRecInternal = curatedRec !== null && curatedRec !== void 0 && curatedRec.hideLabel ? null : curatedRec;
  var tagType = (_curatedRecInternal$l = curatedRecInternal === null || curatedRecInternal === void 0 ? void 0 : curatedRecInternal.label) !== null && _curatedRecInternal$l !== void 0 ? _curatedRecInternal$l : !BLACKLISTED_TAGS.includes(tag) && tag;
  var tagCategory = curatedRecInternal !== null && curatedRecInternal !== void 0 && curatedRecInternal.label ? 'Curated' : '';
  var tagImageData = variant === 'horizontal' && tagType === 'Recommended' ? undefined // hide the avatar on horizontal card so the full 'Recommended' tag fits
  : {
    alt: (_curatedRecInternal$r = curatedRecInternal === null || curatedRecInternal === void 0 ? void 0 : (_curatedRecInternal$r2 = curatedRecInternal.recommender) === null || _curatedRecInternal$r2 === void 0 ? void 0 : _curatedRecInternal$r2.firstName) !== null && _curatedRecInternal$r !== void 0 ? _curatedRecInternal$r : '',
    imageSrc: (_curatedRecInternal$r3 = curatedRecInternal === null || curatedRecInternal === void 0 ? void 0 : (_curatedRecInternal$r4 = curatedRecInternal.recommender) === null || _curatedRecInternal$r4 === void 0 ? void 0 : _curatedRecInternal$r4.avatarSrc) !== null && _curatedRecInternal$r3 !== void 0 ? _curatedRecInternal$r3 : ''
  };

  var handleButtonClick = function handleButtonClick(event) {
    var jsEvent = event.payload.jsEvent;
    jsEvent.stopPropagation();
    dispatch(productCardButtonClicked({
      event: event,
      productId: id,
      cardPosition: cardPosition,
      product: product
    }));
  };

  var handleCardClick = function handleCardClick() {
    dispatch(productCardClicked({
      productId: id,
      referrer: referrer,
      cardPosition: cardPosition,
      product: product
    }));
  };

  var handleLikeDislikeChange = function handleLikeDislikeChange(event) {
    var jsEvent = event.payload.jsEvent;
    jsEvent.stopPropagation();
    dispatch(productLikeStatusChanged({
      event: event,
      productId: id,
      product: product,
      referrer: referrer
    }));
  };
  /**
   * The show variant on hover feature requires local
   * state in order to be fast enough.
   */


  var _React$useState = React.useState(null),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      currentColorVariant = _React$useState2[0],
      setCurrentColorVariant = _React$useState2[1];

  var variantOptions = reduceVariantOptions(variants);
  var displayLikeStatus = likeStatus;
  var displayedImage = image;
  var displayName = name;
  var displayRegularPrice = regularPrice;
  var displaySalePrice = salePrice;

  if (currentColorVariant) {
    var _currentColorVariant$, _currentColorVariant$2, _currentColorVariant$3;

    displayLikeStatus = (_currentColorVariant$ = currentColorVariant === null || currentColorVariant === void 0 ? void 0 : currentColorVariant.likeStatus) !== null && _currentColorVariant$ !== void 0 ? _currentColorVariant$ : likeStatus;
    displayedImage = (_currentColorVariant$2 = currentColorVariant === null || currentColorVariant === void 0 ? void 0 : currentColorVariant.image) !== null && _currentColorVariant$2 !== void 0 ? _currentColorVariant$2 : image;

    if (currentColorVariant !== null && currentColorVariant !== void 0 && currentColorVariant.tag) {
      tagType = currentColorVariant === null || currentColorVariant === void 0 ? void 0 : currentColorVariant.tag;
      tagCategory = '';
      tagImageData = {
        alt: '',
        imageSrc: ''
      };
    }

    displayName = (_currentColorVariant$3 = currentColorVariant === null || currentColorVariant === void 0 ? void 0 : currentColorVariant.name) !== null && _currentColorVariant$3 !== void 0 ? _currentColorVariant$3 : name;
    displayRegularPrice = (currentColorVariant === null || currentColorVariant === void 0 ? void 0 : currentColorVariant.regularPrice) || regularPrice;
    displaySalePrice = (currentColorVariant === null || currentColorVariant === void 0 ? void 0 : currentColorVariant.salePrice) || salePrice;
    showPrice = (displaySalePrice > 0 || displayRegularPrice > 0) && isLoggedIn;
    isUnavailable = !showPrice;
  }

  var handleColorVariantEvent = function handleColorVariantEvent(event) {
    switch (event.type) {
      case 'color-tile-hovered':
        setCurrentColorVariant(event.payload);
        break;

      case 'color-plus-tile-hovered':
      case 'color-tiles-hover-exited':
        setCurrentColorVariant(null);
        break;

      case 'color-tile-clicked':
        {
          var _event$payload = event.payload,
              jsEvent = _event$payload.jsEvent,
              colorVariant = _event$payload.colorVariant;
          jsEvent.stopPropagation();
          dispatch(productCardColorTileClicked({
            colorVariant: colorVariant,
            productId: id,
            product: product,
            referrer: referrer
          }));
          break;
        }
    }
  };

  var Button = styles.Button,
      Card = styles.Card,
      CTAs = styles.CTAs,
      DislikeImageOverlay = styles.DislikeImageOverlay,
      FreeShippingMessage = styles.FreeShippingMessage,
      Image = styles.Image,
      ImageContainer = styles.ImageContainer,
      Meta = styles.Meta,
      MetaBottom = styles.MetaBottom,
      MetaTop = styles.MetaTop,
      OneByOneAspectRatioContainer = styles.OneByOneAspectRatioContainer,
      OutOfStockMessage = styles.OutOfStockMessage,
      OverlaySpinner = styles.OverlaySpinner,
      Pricing = styles.Pricing,
      ProductLikeDislikeButtons = styles.ProductLikeDislikeButtons,
      ProductTag = styles.ProductTag,
      RegularPrice = styles.RegularPrice,
      SalePrice = styles.SalePrice,
      StrikethroughPrice = styles.StrikethroughPrice,
      StyledPromoIcon = styles.StyledPromoIcon;
  return (
    /*#__PURE__*/
    React.createElement(Card, {
      alt: name,
      className: className,
      "data-testid": dataTestId || "product-card-".concat(id),
      onClick: handleCardClick,
      tag: tagType,
      title: name,
      variant: variant
    },
    /*#__PURE__*/
    React.createElement(OneByOneAspectRatioContainer, {
      variant: variant
    },
    /*#__PURE__*/
    React.createElement(ImageContainer, {
      variant: variant
    },
    /*#__PURE__*/
    React.createElement(Image, _extends({
      src: displayedImage,
      alt: displayName,
      bucketName: "modsy",
      height: 256 // fixed size thumbnails
      ,
      width: 256,
      variant: variant
    }, imgixProps))), displayLikeStatus < 0 &&
    /*#__PURE__*/
    React.createElement(DislikeImageOverlay, null), currentState === 'swapping' &&
    /*#__PURE__*/
    React.createElement(DislikeImageOverlay, null,
    /*#__PURE__*/
    React.createElement(OverlaySpinner, {
      size: 14,
      color: grayDarkM
    })), likeDislikeEnabled &&
    /*#__PURE__*/
    React.createElement(ProductLikeDislikeButtons, {
      dislikeButtonConfig: dislikeButtonConfig,
      dispatch: handleLikeDislikeChange,
      isDisliked: displayLikeStatus < 0,
      isLiked: displayLikeStatus > 0
    }), tagType &&
    /*#__PURE__*/
    React.createElement(ProductTag, {
      category: tagCategory,
      imageData: tagImageData,
      type: tagType,
      size: "small"
    })),
    /*#__PURE__*/
    React.createElement(Meta, {
      variant: variant
    },
    /*#__PURE__*/
    React.createElement(MetaTop, null, renderSource({
      source: source,
      tag: tag,
      variant: variant
    }), renderName({
      ctaVisible: ctaVisible,
      isLoggedIn: isLoggedIn,
      isUnavailable: isUnavailable,
      mainType: mainType,
      name: displayName,
      showPrice: showPrice,
      tag: tag,
      variant: variant,
      variantOptions: variantOptions
    })),
    /*#__PURE__*/
    React.createElement(MetaBottom, null, showPrice &&
    /*#__PURE__*/
    React.createElement(Pricing, null, displaySalePrice > 0 ?
    /*#__PURE__*/
    React.createElement(React.Fragment, null,
    /*#__PURE__*/
    React.createElement(SalePrice, null, toUSDString(displaySalePrice)),
    /*#__PURE__*/
    React.createElement(StrikethroughPrice, {
      variant: variant
    }, toUSDString(displayRegularPrice)), promos.length > 0 &&
    /*#__PURE__*/
    React.createElement(StyledPromoIcon, {
      size: 16
    })) :
    /*#__PURE__*/
    React.createElement(React.Fragment, null,
    /*#__PURE__*/
    React.createElement(RegularPrice, null, toUSDString(displayRegularPrice)), promos.length > 0 &&
    /*#__PURE__*/
    React.createElement(StyledPromoIcon, {
      size: 16
    }))), isFreeShipping && !isUnavailable && !isDiscontinued &&
    /*#__PURE__*/
    React.createElement(FreeShippingMessage, null, "Free shipping"), (isUnavailable || isDiscontinued) && isLoggedIn &&
    /*#__PURE__*/
    React.createElement(OutOfStockMessage, null, unavailableText), variantOptions.hasVariants && renderVariants({
      dispatch: handleColorVariantEvent,
      variantOptions: variantOptions,
      variant: variant
    }), ctaVisible &&
    /*#__PURE__*/
    React.createElement(CTAs, {
      variant: variant
    }, secondaryButtonVisible &&
    /*#__PURE__*/
    React.createElement(Button, {
      disabled: buttonConfig.disabled,
      dispatch: handleButtonClick,
      fluid: true,
      id: id,
      labelText: buttonConfig.labelText,
      size: 'xsmall'
    })))))
  );
}

ProductCard.propTypes = {
  /** The product availability status. */
  availabilityV2: PropTypes.shape({
    status: PropTypes.string
  }),

  /** Call to action button configuration. */
  buttonConfig: PropTypes.shape({
    visible: PropTypes.bool,
    disabled: PropTypes.bool,
    labelText: PropTypes.string,
    atcVisible: PropTypes.bool,
    atcDisabled: PropTypes.bool
  }),

  /** Current state of product instance. One of:  */
  currentState: PropTypes.oneOf(['', 'swapping']),

  /** Optional data-testid override.
   * If override is not provided defaults to `product-card-${id}`
   */
  dataTestId: PropTypes.string,

  /** Passed through to LikeDislikeButtons component. */
  dislikeButtonConfig: PropTypes.oneOf(['hover', 'always', 'never']),

  /** The product's unique id */
  id: PropTypes.string,

  /** Full URL to representative or thumbnail image for product. */
  image: PropTypes.string,

  /** Allows overriding Imgix configuration
   * This object will be spread onto the CompressedImage props.
   */
  imgixProps: PropTypes.object,

  /**
  * Whether a user is logged in.
  * Preset to 'true' in order to show prices by default.
  */
  isLoggedIn: PropTypes.bool,

  /** [Deprecated] Flag for whether a product is out of stock
   * Prefer availabilityV2.status where available.
  */
  isOutOfStock: PropTypes.bool,

  /**
   * Whether this product can be sold to customers or not
   */
  isSellable: PropTypes.bool,

  /**
   * Whether this product is restricted/is not an actual sellable product
   */
  isRestricted: PropTypes.bool,

  /** Whether or not to show the like/dislike buttons */
  likeDislikeEnabled: PropTypes.bool,

  /** Whether or not the product has been liked or disliked by the current user.
   * Any value greater than zero means the product has been liked.
   * Any value less than zero means the product has been disliked.
   * A value of 0 means user has provided no preference w.r.t. the product.
   */
  likeStatus: PropTypes.number,

  /** The product's name. */
  name: PropTypes.string,

  /** The product's associated promos */
  promos: PropTypes.arrayOf(PropTypes.string),

  /** The string value of the referrer */
  referrer: PropTypes.oneOf(['alternative', 'favorites', 'hotspot', 'products_in_design', 'design_alternatives', '']),

  /** The product's regular price. */
  regularPrice: PropTypes.number,

  /** The product's sale price. */
  salePrice: PropTypes.number,

  /** The product's primary retailer, e.g., CB2. */
  source: PropTypes.string,

  /** Optional product tag. One of: */
  tag: PropTypes.oneOf(['Sale', 'Stand-in', 'Exact match', 'New', 'In design', '']),

  /** Available product variants options. */
  variants: PropTypes.shape({
    colors: PropTypes.array,
    sizes: PropTypes.array
  }),

  /** Latest Product CTA messaging fields, as of 5/2021 */
  uiMessaging: PropTypes.shape({
    ctaTitle: PropTypes.string,
    isSellable: PropTypes["boolean"]
  }),

  /** used for style/behavior variants */
  variant: PropTypes.oneOf(VARIANTS)
};
/**
 * Helpers
 */

function renderName(_ref2) {
  var ctaVisible = _ref2.ctaVisible,
      isLoggedIn = _ref2.isLoggedIn,
      isUnavailable = _ref2.isUnavailable,
      mainType = _ref2.mainType,
      name = _ref2.name,
      showPrice = _ref2.showPrice,
      tag = _ref2.tag,
      variant = _ref2.variant,
      variantOptions = _ref2.variantOptions;

  if (variant === 'thin') {
    return null;
  }

  var Name = styles.Name,
      NameAlt = styles.NameAlt;
  var isCustomProp = tag === 'Stand-in' || tag === 'Exact match';
  var Component = isCustomProp || variant === 'borderless' ? NameAlt : Name;
  var nameStr = isCustomProp ? toSentenceCase(mainType) : name; // This ensures prices are aligned across product cards in a grid.

  var useFixedHeight = !isCustomProp && variant !== 'horizontal' && ctaVisible && (showPrice || isLoggedIn && isUnavailable);
  var fixedHeightStyles = useFixedHeight ? {
    height: '2.25rem'
  } : undefined; // Logic for deciding how many lines to truncate the name.

  var lines = variant === 'horizontal' && variantOptions.hasVariants ? 1 : 2;
  return (
    /*#__PURE__*/
    React.createElement(Component, {
      lines: lines,
      style: fixedHeightStyles
    }, nameStr)
  );
}

function renderSource(_ref3) {
  var source = _ref3.source,
      tag = _ref3.tag,
      variant = _ref3.variant;
  var Source = styles.Source;
  var sourceStr = source;

  if (tag === 'Exact match') {
    sourceStr = 'Exact match of your';
  } else if (tag === 'Stand-in') {
    sourceStr = 'In place of your';
  }

  return (
    /*#__PURE__*/
    React.createElement(Source, {
      variant: variant
    }, sourceStr)
  );
}

function renderVariants(_ref4) {
  var _ref4$dispatch = _ref4.dispatch,
      dispatch = _ref4$dispatch === void 0 ? function () {} : _ref4$dispatch,
      _ref4$variantOptions = _ref4.variantOptions,
      variantOptions = _ref4$variantOptions === void 0 ? {} : _ref4$variantOptions,
      _ref4$variant = _ref4.variant,
      variant = _ref4$variant === void 0 ? '' : _ref4$variant;
  var colors = variantOptions.colors,
      dimensions = variantOptions.dimensions;
  var colorsCnt = colors.length;
  var sizeCnt = dimensions.length;
  var displayColors = [];

  if (variant === 'horizontal') {
    displayColors = sizeCnt === 0 ? colors.slice(0, colorsCnt > 7 ? 6 : colorsCnt) : colors.slice(0, colorsCnt > 5 ? 4 : colorsCnt);
  } else {
    displayColors = sizeCnt === 0 ? colors.slice(0, colorsCnt > 6 ? 5 : colorsCnt) : colors.slice(0, colorsCnt > 4 ? 3 : colorsCnt);
  }

  return (
    /*#__PURE__*/
    React.createElement(VariantsContainer, {
      style: variant === 'horizontal' ? {
        paddingBottom: 0
      } : undefined
    },
    /*#__PURE__*/
    React.createElement(ColorTiles, {
      onMouseLeave: function onMouseLeave() {
        return dispatch({
          type: 'color-tiles-hover-exited'
        });
      }
    }, displayColors.length > 1 && displayColors.map(function (colorVariant, index) {
      var displayType = colorVariant.displayType,
          label = colorVariant.label,
          value = colorVariant.value;
      var bgColor = displayType === 'hex' ? "#".concat(value) : backgroundGrayLightM;
      return (
        /*#__PURE__*/
        React.createElement(ColorTile, {
          bgColor: bgColor,
          key: value,
          onClick: function onClick(jsEvent) {
            return dispatch({
              type: 'color-tile-clicked',
              payload: {
                jsEvent: jsEvent,
                colorVariant: colorVariant
              }
            });
          },
          onMouseEnter: function onMouseEnter() {
            return dispatch({
              type: 'color-tile-hovered',
              payload: colorVariant
            });
          }
        }, displayType === 'image' &&
        /*#__PURE__*/
        React.createElement(CompressedImage, {
          src: value,
          alt: label,
          bucketName: "modsy",
          height: 'auto',
          width: 64,
          style: {
            borderRadius: '2px',
            height: '1rem',
            width: '1rem',
            objectFit: 'cover'
          }
        }))
      );
    }), colorsCnt > 0 && displayColors.length < colorsCnt &&
    /*#__PURE__*/
    React.createElement(ColorTile, {
      bgColor: backgroundGrayLightM,
      onMouseEnter: function onMouseEnter() {
        return dispatch({
          type: 'color-plus-tile-hovered'
        });
      }
    }, "+")), sizeCnt > 0 &&
    /*#__PURE__*/
    React.createElement(SizeLabel, null, "".concat(sizeCnt, " sizes")))
  );
}

function reduceVariantOptions() {
  var variants = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _reduce = ((variants === null || variants === void 0 ? void 0 : variants.variantOptions) || []).reduce(function (acc, option) {
    if ((option === null || option === void 0 ? void 0 : option.type) === 'color') {
      acc.colors = option.options;
    } else if ((option === null || option === void 0 ? void 0 : option.type) === 'dimensions') {
      acc.dimensions = option.options;
    } else if ((option === null || option === void 0 ? void 0 : option.type) === 'size' && acc.dimensions.length === 0) {
      acc.dimensions = option.options;
    }

    return acc;
  }, {
    colors: [],
    dimensions: []
  }),
      colors = _reduce.colors,
      dimensions = _reduce.dimensions;

  var colorsCnt = colors.length;
  var dimsCnt = dimensions.length;
  var hasVariants = colorsCnt > 1 || dimsCnt > 0;
  return {
    colors: colors,
    dimensions: dimensions,
    hasVariants: hasVariants
  };
}

var VariantsContainer = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  align-content: center;\n  justify-content: space-between;\n\n  padding: 0.5rem 0 0.25rem 0;\n"])));
var ColorTiles = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n"])));
var ColorTile = styled.button(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  appearance: none;\n  border: none;\n  outline: none;\n\n  height: 1rem;\n  width: 1rem;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n\n  background-color: ", ";\n  border-radius: 2px;\n  cursor:pointer;\n  font-family: ", ";\n  font-size: 0.75rem;\n  line-height: 1rem;\n  margin-right: 0.25rem;\n  padding: 0;\n\n  /* render an outer border on hover */\n  &:hover {\n    &:before {\n      content: \" \";\n      position: absolute;\n      top: -1px;\n      bottom: -1px;\n      left: -1px;\n      right: -1px;\n      border: 1px solid ", ";\n      border-radius: 3px;\n    }\n  }  \n"])), function (p) {
  return p.bgColor;
}, fontFamilyPrimary, selectedLightM);
var SizeLabel = styled.p(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  color: ", ";\n  font-family: ", ";\n  font-size: 0.625rem;\n  line-height: 0.75rem;\n  margin: 0;\n"])), textPrimaryM, fontFamilyPrimary);
/**
 * Styles
 */

var Image = styled(CompressedImage)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n\n  ", "\n"])), function (props) {
  return (props.variant === 'borderless' || props.variant === 'thin') && "\n    border: 1px solid ".concat(grayLightM, ";\n    border-radius: 4px;\n  ");
});
var styles = {
  Card: styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: column;\n    background-color: ", ";\n    border-radius: 4px;\n    cursor: pointer;\n    max-width: 16rem;\n    min-width: 8rem;\n    overflow: hidden;\n    border: 1px solid ", ";\n    transition: border 300ms ease-out;\n\n    @media (hover: hover) {\n      &:hover {\n        border-color: ", ";\n      }\n    }\n\n    &:active {\n      border-color: ", ";\n    }\n\n    ", "\n\n    ", "\n\n    ", "\n\n    ", "\n  "])), surfaceM, grayLightM, selectedLightM, selectedM, function (props) {
    return props.variant === 'horizontal' && "\n      align-items: center;\n      width: 100%;\n      min-width: 18rem;\n      max-width: 21.4375rem;\n      flex-direction: row;\n      border-radius: 4px;\n      min-height: 9rem;\n    ";
  }, function (props) {
    return props.variant === 'thin' && "\n      min-width: 7rem;\n      padding: 0.25rem;\n    ";
  }, function (props) {
    return (props.variant === 'borderless' || props.variant === 'thin' && props.tag !== 'In design') && "\n      background-color: transparent;\n      border: none;\n\n      @media (hover: hover) {\n        &:hover {\n          ".concat(Image, " {\n            border-color: ").concat(selectedLightM, ";\n          }\n        }\n      }\n\n      &:active {\n        ").concat(Image, " {\n          border-color: ").concat(selectedM, ";\n        }\n      }\n    ");
  }, function (props) {
    return props.variant === 'thin' && props.tag === 'In design' && "\n      background-color: transparent;\n      border: 1px solid ".concat(selectedM, ";\n    ");
  }),
  OneByOneAspectRatioContainer: styled.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n    height: 0;\n    padding-bottom: 100%;\n    width: 100%;\n\n    background-color: ", ";\n    position: relative;\n\n    ", "\n  "])), surfaceM, function (props) {
    return props.variant === 'horizontal' && "\n      padding-bottom: unset;\n      height: 9rem;\n      width: 9rem;\n      flex-shrink: 0;\n    ";
  }),
  ImageContainer: styled.div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n    position: absolute;\n    top: 0;\n    left: 0;\n    height: 100%;\n    width: 100%;\n\n    ", "\n\n    /** Ensure non 1x1 product images are centered. */\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  "])), function (props) {
    return props.variant === 'horizontal' && "\n      /** Helps to vertically align the image */\n      position: relative;\n\n      img {\n        max-height: 9rem;\n      }\n    ";
  }),
  DislikeImageOverlay: styled.div(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background: linear-gradient(0deg, rgba(255, 255, 255, 0.6), rgba(255, 255, 255, 0.6));\n  "]))),
  OverlaySpinner: styled(RoundedSpinner)(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  "]))),
  Image: Image,
  ProductLikeDislikeButtons: styled(LikeDislikeButtons)(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n    position: absolute;\n    top: 0.5rem;\n    right: 0.5rem;\n  "]))),
  Meta: styled.div(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: column;\n    flex-grow: 1;\n    justify-content: space-between;\n\n    background-color: ", ";\n    border-top: none;\n    border-radius: 0 0 4px 4px;\n    padding: 0.5rem;\n\n    ", "\n\n    ", "\n  "])), surfaceM, function (props) {
    return props.variant === 'horizontal' && "\n      border: none;\n      border-radius: 0;\n    ";
  }, function (props) {
    return (props.variant === 'borderless' || props.variant === 'thin') && "\n      background-color: transparent;\n      border-radius: 0;\n      padding: 0.5rem 0 0 0;\n    ";
  }),
  MetaTop: styled.div(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: column;\n  "]))),
  MetaBottom: styled.div(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: column;\n    flex-grow: 1;\n    justify-content: space-between;\n  "]))),
  Source: styled.p(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n    ", ";\n\n    /** Truncate to 1 line. */\n    ", ";\n\n    ", "\n  "])), LabelSmallStyles, truncateLines({
    lines: 1
  }), function (props) {
    return (props.variant === 'borderless' || props.variant === 'thin') && "\n      margin-bottom: 0.25rem;\n    ";
  }),
  Name: styled.p(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n    ", ";\n    margin-bottom: 0.25rem;\n\n    /** Truncate to 2 lines. */\n    ", ";\n  "])), BodySmallSmallStyles, truncateLines({
    lines: function lines(props) {
      return props.lines;
    }
  })),
  NameAlt: styled.p(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["\n    ", ";\n    margin-bottom: 0.25rem;\n\n    /** Truncate to 2 lines. */\n    ", ";\n  "])), BodySmallBoldLargeStyles, truncateLines({
    lines: 2
  })),
  FreeShippingMessage: styled.div(_templateObject18 || (_templateObject18 = _taggedTemplateLiteral(["\n    ", ";\n    margin-top: 0.25rem;\n  "])), BodySmallStyles),
  OutOfStockMessage: styled.div(_templateObject19 || (_templateObject19 = _taggedTemplateLiteral(["\n    ", ";\n    white-space: nowrap;\n  "])), BodySmallLargeStyles),
  Pricing: styled.div(_templateObject20 || (_templateObject20 = _taggedTemplateLiteral(["\n    display: flex;\n    align-items: center;\n  "]))),
  RegularPrice: styled.p(_templateObject21 || (_templateObject21 = _taggedTemplateLiteral(["\n    ", ";\n  "])), BodySmallBoldLargeStyles),
  SalePrice: styled.p(_templateObject22 || (_templateObject22 = _taggedTemplateLiteral(["\n    ", ";\n    color: ", ";\n    margin-right: 0.5rem;\n\n    ", "   \n  "])), BodySmallBoldLargeStyles, primaryHighlightM, function (props) {
    return props.variant === 'thin' && "\n      flex-shrink: 0;\n      margin-right: 0.25rem;\n    ";
  }),
  StrikethroughPrice: styled.p(_templateObject23 || (_templateObject23 = _taggedTemplateLiteral(["\n    ", "\n    color: ", ";\n    text-decoration: line-through;\n\n    ", "\n  "])), LabelSmallStyles, textPrimaryM, function (props) {
    return props.variant === 'thin' && "\n      flex-shrink: 1;\n      ".concat(truncateLines({
      lines: 1
    }), ";\n    ");
  }),
  ProductTag: styled(Tag)(_templateObject24 || (_templateObject24 = _taggedTemplateLiteral(["\n    position: absolute;\n    bottom: 0.5rem;\n    left: 0.5rem;\n  "]))),
  CTAs: styled.div(_templateObject25 || (_templateObject25 = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    margin-top: 0.5rem;\n\n    ", "\n  "])), function (props) {
    return props.variant === 'borderless' && "\n      margin-top: 0.75rem;\n    ";
  }),
  Button: styled(SecondaryButton)(_templateObject26 || (_templateObject26 = _taggedTemplateLiteral(["\n    height: 2.125rem;\n    min-height: 2.125rem;\n    font-weight: ", ";\n    line-height: 1.125rem;\n  "])), fontWeightSemiBold),
  AddToCartCta: styled(AddToCartButton)(_templateObject27 || (_templateObject27 = _taggedTemplateLiteral(["\n    flex-shrink: 0;\n    margin-right: 0.25rem;\n  "]))),
  StyledPromoIcon: styled(PromoIcon)(_templateObject28 || (_templateObject28 = _taggedTemplateLiteral(["\n    flex-shrink: 0;\n    margin-left: 0.25rem;\n  "])))
};
export default ProductCard;
export { ProductCardReferrer };